/**
 *
 * @param url
 * @returns {boolean}
 */
function isRelativeUrl(url) {
    return !/^(?:[a-z]+:)?\/\//i.test(url);
}

function fullUrl(url) {
    if (isRelativeUrl(url)) {
        url = window.location.protocol + "//" + getDomainFromUrl(window.location.href) + url;
    }
    return url;
}

function getDomainFromUrl(url) {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname;
}

/**
 *
 * @param link
 * @returns {boolean}
 */
function isLinkOutbound(link) {
    const currentUrl = window.location.href;
    return getDomainFromUrl(currentUrl) !== getDomainFromUrl(link);
}
/**
 *
 * @param $element Element
 */
function processNavigationClick($element){
    let linkData = $element.dataset['track'];
    if(linkData === 'click'){
        linkData = {};
        linkData.buttonText = $element.dataset['trackButtonText'];
        linkData.locationInPage = $element.dataset['trackLocationInPage'];
    }
    let data = {
        action: '',
        label: ''
    }

    if (typeof trackingData != 'undefined' && typeof linkData != 'undefined') {
        data.action = linkData.action;
        data.label = linkData.label;
    }
    let link;
    let buttonText;
    if($element.tagName === 'A'){
        link = $element.href;
        buttonText = linkData?.buttonText??$element.innerText;
    }
    if($element.tagName === 'BUTTON'){
        link = $element.dataset['link']
        buttonText = $element.querySelector('.MainHeaderV2__buttonLabel')?.innerText;
    }
    if(!link){
        return true;
    }
    link = fullUrl(link)
    if (link && typeof link !== "undefined") {
        data.outbound = isLinkOutbound(link);
        data.locationInPage = linkData && linkData.locationInPage ? linkData.locationInPage : 'general';
        data.link_classes = [$element.classList].join(' ');
        data.link_domain = getDomainFromUrl(link);
        data.destination = link;
        data.link_url = link;
        data.buttonText = buttonText.trim();
    }
    if (linkData && linkData.vehicleId) {
        data.vehicleId = linkData.vehicleId;
    }
    if (linkData && linkData.vehicleModel) {
        data.vehicleModel = linkData.vehicleModel;
    }
    trackEvent(data, 'navigationClick');
}
$(document).ready(function () {
    if(ORIGIN !== undefined){
        document.querySelectorAll('a').forEach(link => {
            if(isLinkOutbound(link.href) === true){
                const url = new URL(link.href, window.location.origin);
                url.searchParams.set('ORIGIN', ORIGIN);
                link.href = url.toString();
            }

        });

    }

    $('body').on('click', '.MainHeaderV2__button, .MyAccount__container', function (ev) {
        processNavigationClick($(this)[0]);
    })
    .on('click', 'a', function (ev) {
        processNavigationClick($(this)[0]);
        if ($(this).hasClass('SubNav__link') && $('body').hasClass('optimize-variant-1')) {
            $('.SubNav__linkItem, ul.SubNav_Cars').removeClass('is-active');
            $(this).parent().addClass('is-active');
            $('.SubNav__contentCars, ul.SubNav_Cars.nav-' + $(this).data('nav')).addClass('is-active');
            return false;
        }
    });

});